// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sidebar-container {
  display: flex;
  flex-direction: column;
  min-width: 280px;
  border-right: 1px solid var(--dee3);
}
#sidebar-container .side-option-container {
  width: 100%;
}
#sidebar-container .side-option-container .side-menu-block {
  display: flex;
  align-items: center;
  padding-top: 18px;
  padding-bottom: 18px;
  padding-left: 38px;
  cursor: pointer;
}
#sidebar-container .side-option-container .side-menu-block .side-icon-block {
  height: 26px;
}
#sidebar-container .side-option-container .side-menu-block .side-title-block {
  padding-left: 12px;
  font-size: 18px;
  font-weight: 400;
  font-family: "f-400";
  color: #777e91;
}
#sidebar-container .side-option-container .active-side-menu {
  background-color: #f8f9fb;
}
#sidebar-container .side-option-container .active-side-menu .side-title-block {
  color: var(--56ff);
  font-weight: 600;
  font-family: "f-600";
}
#sidebar-container .version {
  top: 18px;
  left: 213px;
}

#sidebar-container-dark {
  display: flex;
  flex-direction: column;
  min-width: 280px;
  border-right: 1px solid var(--4d6c);
}
#sidebar-container-dark .side-option-container {
  width: 100%;
}
#sidebar-container-dark .side-option-container .side-menu-block {
  display: flex;
  align-items: center;
  padding-top: 18px;
  padding-bottom: 18px;
  padding-left: 38px;
  cursor: pointer;
}
#sidebar-container-dark .side-option-container .side-menu-block .side-icon-block {
  height: 26px;
}
#sidebar-container-dark .side-option-container .side-menu-block .side-title-block {
  padding-left: 12px;
  font-size: 18px;
  font-weight: 400;
  font-family: "f-400";
  color: var(--c9c9);
}
#sidebar-container-dark .side-option-container .active-side-menu {
  background-color: var(--4d6c);
}
#sidebar-container-dark .side-option-container .active-side-menu .side-title-block {
  color: var(--ffff);
  font-weight: 600;
  font-family: "f-600";
}
#sidebar-container-dark .version {
  top: 18px;
  left: 213px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Layout/Sidebar/Sidebar.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,mCAAA;AACF;AAAE;EACE,WAAA;AAEJ;AADI;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;AAGN;AAFM;EACE,YAAA;AAIR;AAFM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;AAIR;AADI;EACE,yBAAA;AAGN;AADM;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;AAGR;AACE;EACE,SAAA;EACA,WAAA;AACJ;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,mCAAA;AAAF;AACE;EACE,WAAA;AACJ;AAAI;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;AAEN;AADM;EACE,YAAA;AAGR;AADM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;AAGR;AAAI;EACE,6BAAA;AAEN;AAAM;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;AAER;AAEE;EACE,SAAA;EACA,WAAA;AAAJ","sourcesContent":["#sidebar-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 280px;\r\n  border-right: 1px solid var(--dee3);\r\n  .side-option-container {\r\n    width: 100%;\r\n    .side-menu-block {\r\n      display: flex;\r\n      align-items: center;\r\n      padding-top: 18px;\r\n      padding-bottom: 18px;\r\n      padding-left: 38px;\r\n      cursor: pointer;\r\n      .side-icon-block {\r\n        height: 26px;\r\n      }\r\n      .side-title-block {\r\n        padding-left: 12px;\r\n        font-size: 18px;\r\n        font-weight: 400;\r\n        font-family: \"f-400\";\r\n        color: #777e91;\r\n      }\r\n    }\r\n    .active-side-menu {\r\n      background-color: #f8f9fb;\r\n\r\n      .side-title-block {\r\n        color: var(--56ff);\r\n        font-weight: 600;\r\n        font-family: \"f-600\";\r\n      }\r\n    }\r\n  }\r\n  .version {\r\n    top: 18px;\r\n    left: 213px;\r\n  }\r\n}\r\n\r\n#sidebar-container-dark {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 280px;\r\n  border-right: 1px solid var(--4d6c);\r\n  .side-option-container {\r\n    width: 100%;\r\n    .side-menu-block {\r\n      display: flex;\r\n      align-items: center;\r\n      padding-top: 18px;\r\n      padding-bottom: 18px;\r\n      padding-left: 38px;\r\n      cursor: pointer;\r\n      .side-icon-block {\r\n        height: 26px;\r\n      }\r\n      .side-title-block {\r\n        padding-left: 12px;\r\n        font-size: 18px;\r\n        font-weight: 400;\r\n        font-family: \"f-400\";\r\n        color: var(--c9c9);\r\n      }\r\n    }\r\n    .active-side-menu {\r\n      background-color: var(--4d6c);\r\n\r\n      .side-title-block {\r\n        color: var(--ffff);\r\n        font-weight: 600;\r\n        font-family: \"f-600\";\r\n      }\r\n    }\r\n  }\r\n  .version {\r\n    top: 18px;\r\n    left: 213px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
